"use client";

import { SessionProvider } from "next-auth/react";

import { AUTHZ_JWT_TTL_MS } from "@/constants/auth";
import { SessionAuthzRefresh } from "@/lib/auth/session-authz-refresh";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      refetchOnWindowFocus
      refetchInterval={AUTHZ_JWT_TTL_MS / 1000}
    >
      <SessionAuthzRefresh />
      {children}
    </SessionProvider>
  );
}
